import GlideSliderProvider from "../_shared/GlideSliderProvider";
customElements.define('block-social-posts', class extends HTMLElement {
  connectedCallback() {
    new GlideSliderProvider("block-social-posts")
      .setEnableSliderMobile(true)
      .setEnableSliderDesktop(false)
      .init(".js-block-social-posts__list");
  }
});